const productionAccessTokenKey = 'positivehotel-yoga-client-accessToken';
const developmentAccessTokenKey = 'dev-positivehotel-yoga-client-accessToken';
const localAccessTokenKey = 'local-positivehotel-yoga-client-accessToken';

export const getLocalAccessToken = () => {
    if (process.env.REACT_APP_ENV === 'production') {
        let accessToken = localStorage.getItem(productionAccessTokenKey);
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.native_yoga_bridge) {
            window.webkit.messageHandlers.native_yoga_bridge.postMessage(JSON.stringify({
                functionName: 'getInjectedHardwareValue',
                data: {
                    "key": "accessToken"
                }
            }))
            window.getInjectedHardwareValue = (accessTokenFromDevice: string) => {
                if (accessTokenFromDevice && accessTokenFromDevice !== "not found value to device") {
                    localStorage.setItem(productionAccessTokenKey, accessTokenFromDevice);
                    accessToken = accessTokenFromDevice;
                }
            }
        }
        if (accessToken === 'undefined' || !accessToken) return null;
        return accessToken;
    } else if (process.env.REACT_APP_ENV === 'development') {
        const accessToken = localStorage.getItem(developmentAccessTokenKey);
        if (accessToken === 'undefined' || !accessToken) return null;
        return accessToken;
    } else if (process.env.REACT_APP_ENV === 'local') {
        const accessToken = localStorage.getItem(localAccessTokenKey);
        if (accessToken === 'undefined' || !accessToken) return null;
        return accessToken;
    }
    return null;
};
export const setUser = (accessToken: string) => {
    if (process.env.REACT_APP_ENV === 'production') {
        localStorage.setItem(productionAccessTokenKey, accessToken);
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.native_yoga_bridge) {
            window.webkit.messageHandlers.native_yoga_bridge.postMessage(JSON.stringify({
                functionName: 'injectValueToHarware',
                data: {
                    "key": "accessToken",
                    "value": accessToken
                }
            }))
        }
    } else if (process.env.REACT_APP_ENV === 'development') {
        localStorage.setItem(developmentAccessTokenKey, accessToken);
    } else if (process.env.REACT_APP_ENV === 'local') {
        localStorage.setItem("local-positivehotel-yoga-client-accessToken", accessToken);
    }

};
export const removeUser = () => {
    if (process.env.REACT_APP_ENV === 'production') {
        localStorage.removeItem(productionAccessTokenKey);
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.native_yoga_bridge) {
            window.webkit.messageHandlers.native_yoga_bridge.postMessage(JSON.stringify({
                functionName: 'injectValueToHarware',
                data: {
                    "key": "accessToken",
                    "value": ""
                }
            }))
        }
    } else if (process.env.REACT_APP_ENV === 'development') {
        localStorage.removeItem(developmentAccessTokenKey);
    } else if (process.env.REACT_APP_ENV === 'local') {
        localStorage.removeItem(localAccessTokenKey);
    }
};